import { CSSProperties, ReactNode, useEffect, useId, useRef, useState } from 'react'
import { Modal } from 'rsuite'
import { ModalSize } from 'rsuite/esm/Modal'
import { Button } from './Controls'
import { ModalReadyContext } from './modalReady'

type TButton = {
  label: string,
  status: string,
  disabled?: boolean,
  visible?: boolean
}

type TDialog = {
  id?: string,
  title: string,
  content?: string,
  buttons: TButton[],
  onClick: any,
  params?: any,
  size?: ModalSize,
  autoScroll?: boolean,
  children?: ReactNode,
  fullHeight?: boolean,
}

const FooterStyle = {
  paddingTop: '1.25em'
} as CSSProperties
const ModalBodyStyle = {
  padding: '20px 20px 0',
  margin: '0 -20px',
} as CSSProperties

const ModalDialog = ({ title, content, buttons, onClick, params, id = '', size = 'xs', autoScroll = true, fullHeight = false, children, ...rest }: TDialog) => {
  const [open, setOpen] = useState(true)
  const bodyRef = useRef(null);
  //
  // Whether the dialog has finished opening. Only a table waits for it (see
  // components/modalReady.ts and Controls/Table.tsx); everything else renders
  // straight away, so a dialog without a table opens exactly as before.
  //
  const [entered, setEntered] = useState(false)

  // handle min-height style to max-height
  // to see the dialog as full height dialog
  useEffect(() => {
    if (!open || !fullHeight) return;

    const updateHeight = () => {
      const el: any = bodyRef.current;
      if (!el) return;

      const computed = window.getComputedStyle(el);
      const maxHeight = computed.maxHeight;

      if (maxHeight && maxHeight !== 'none') {
        el.style.minHeight = maxHeight;
      }
    };

    // Initial setzen
    setTimeout(() => {
      updateHeight();
    }, 100);

    // Bei Resize aktualisieren
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [open]);

  const handleClose = (status: any) => {
    if (!onClick) {
      setOpen(false)
    }
    else if (onClick(status, params)) {
      setOpen(false)
    }
  }

  return (
    <Modal
      id={id || useId()}
      backdrop="static"
      size={size}
      overflow={autoScroll}
      open={open}
      onClose={() => handleClose('cancel')}
      onEntered={() => setEntered(true)}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body ref={bodyRef} style={ModalBodyStyle}>
        <ModalReadyContext.Provider value={entered}>
          {
            content
              ? <div dangerouslySetInnerHTML={{ __html: content }}></div>
              : children
          }
        </ModalReadyContext.Provider>
      </Modal.Body>
      <Modal.Footer style={FooterStyle}>
        {
          buttons.map(button => {
            return (
              <Button
                key={button.status}
                appearance="primary"
                disabled={button.disabled || false}
                visible={button.visible || true}
                onClick={() => handleClose(button.status)}
              >
                {button.label}
              </Button>
            )
          })
        }
      </Modal.Footer>
    </Modal>
  )
}
export default ModalDialog